import { type, value } from '@capital-access/common/user';

export class LicenseAgreementPreferences {
  // will be handled in a separate story
  // @value(type.boolean) accepted = false;
  @value(type.boolean) trialAccepted = false;
}
